import { render, staticRenderFns } from "./display.vue?vue&type=template&id=56f2abda&scoped=true"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"
import style0 from "./display.vue?vue&type=style&index=0&id=56f2abda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2abda",
  null
  
)

export default component.exports